// extracted by css-extract-rspack-plugin
export default {"cls1":"Typeahead-cls1_9V4","cls2":"Typeahead-cls2_r41 Typeahead-cls1_9V4","selected":"Typeahead-selected_S1j"};